import { stringify } from 'qs'

import { useCustomSWR } from 'utils/hooks/fetchers'

export const useVenders = (props, swrOptions) => {
  const genUrl = () => {
    try {
      const propsObject = typeof props === 'function' ? props() : props
      if (propsObject === null) {
        return null
      }
      return `/venders?${stringify({
        limit: 15,
        ...propsObject,
        isFilterListVisible: true,
      })}`
    } catch (err) {
      return null
    }
  }
  return useCustomSWR(genUrl, swrOptions)
}
